<template>
  <div class="china-topics-content" @click="clickNode">
    <div class="topics-title">
      <p>Provincial Situation</p>
    </div>
    <div class="national-content">
      <div class="left-content">
        <!--      知识信息-->
        <div class="left-know-message">
          <p class="left-know-message-title">{{ conceptName }}</p>
          <knowledge-card :value="knowledgeValue" class="knowledge-card" id="knowledge-card"></knowledge-card>
        </div>
        <div class="left-bottom-content">
          <div class="left-keyword">
            <router-link :to="{name: 'Macro'}" class="more-btn middle-hidden">More>></router-link>
            <p class="title" title="Provincial macro data">Provincial macro data</p>
            <classify-tabs :value="moreLine.select"
                           class="keyword-tabs"
                           @changeTab="(a,b,c)=>changeMoreLineValue(c)"></classify-tabs>
            <more-line
                title="National Import and Export"
                :value="moreLine.value"
                class="more-line"></more-line>
            <!--            <div class="no-data" v-else>no data</div>-->
          </div>
          <div class="bars-wrap">
            <el-select
                v-if="pieValues.length"
                v-model="showPieIndex"
                size="mini"
                :popper-append-to-body="false"
                class="pie-select">
              <el-option v-for="(item, key) in years" :key="key" :value="key" :label="item"></el-option>
            </el-select>
            <pie title="ODI destinations"
                 :value="pieValues.length ? pieValues[showPieIndex] : []"></pie>
          </div>

        </div>
        <!--                <div class="nagative-bar-box common-sm">-->
        <!--                </div>-->
        <!--                <div class="left-bottom">-->
        <!--                </div>-->
      </div>
      <!--      可视化图谱-->
      <div class="content-graph pr-sm-0 pl-sm-0" :class="[isFull?'fullscreen':'']">
        <div class="graph-wrap" id="graph-wrap">
          <div class="search-top" v-if="graphValue.graph">
            <div class="input_box">
              <input
                  type="text"
                  v-model="filter.searchmatter"
                  @blur.prevent="clearSearch"
                  @click="clickSearch"
                  class="form-control pl-4"
                  placeholder="Please enter province"
                  v-on:keyup.enter="search()">
              <i class="fa fa-search search_icon" @click="search()"></i>
              <div class="nav_search" v-show="isSearch && searchList && searchList.length">
                <div v-for="item in searchList" @click="changeSearchEntity(item.name)">{{ item.name }}
                </div>
              </div>
            </div>
            <date-range
                :value.sync="dataPicker"
                class="data-picker"
                @change="search">
            </date-range>
            <!--                        <el-select v-model="filter.timeFilter" placeholder="选择时间"-->
            <!--                                   @change="search">-->
            <!--                            <el-option v-for="(item, index) in timeOption" :key="index"-->
            <!--                                       :label="item.label"-->
            <!--                                       :value="item.value"></el-option>-->
            <!--                        </el-select>-->
          </div>
          <div v-if="graphValue.graph" class="graph-draw">
            <img src="../../../assets/images/drawDom.png" class="cut-button"
                 @click="drawDom('.pd-main-container', '国家专区')"/>
          </div>
          <country-graph
              class="country-graph" :value="graphValue" :is-all="false"
              @changeGraph="changeGraph"
              :is-roll-zomm="true"
              :is-layout="true"
              :is-real-full="false"
              is-full=".graph-wrap"
              @changePage="changeGraphPage"
              :isContextmenu="true"
              @fullGraph="fullGraph"
              ref="graph"
              @contextmenuClick="jumpSearch"
              @doubleClick="addNode"></country-graph>
        </div>
        <div class="classfy-content" v-if="itemDetailCreate">
          <div class="classfy-content-head">
            <classfy-bread-crumb :value="breadCrumbValue"
                                 @change="changeType"
                                 :activeItem="selectType">
            </classfy-bread-crumb>
            <el-button size="mini" slot="label" type="primary" @click="selectTab"
                       class="select-button" style="outline: none">
              select
            </el-button>
          </div>
          <select-popcomfirm :value="selectValue" class="select-dialog-wrap"
                             v-show="selectVisible"
                             :isCascader="false"
                             ref="selectPopcomfirm"
                             @selectItem="selectItem"></select-popcomfirm>
          <selection-list :value="itemDetailValue"
                          :is-keep="isKeep"
                          :key="selectType"
                          class="item-wrap"
                          @change="gotoSearchDetail"
                          @jumpList="requestAllData"></selection-list>
        </div>
        <div v-else class="classfy-content"></div>
      </div>
      <div class="right-message pr-sm-0 pl-sm-0 d-none d-xl-flex d-lg-flex">
        <video-list class="relation-material" :value="videoMessage.content"
                    ref="videoList"
                    @update="requestVideoList"></video-list>
        <!--                <relation-material class="left-relation-material" :material-list="allMaterialList.data"-->
        <!--                                   @gotoUrl="gotoDetail"></relation-material>-->
        <!--          相关材料-->
        <relation-material class="left-relation-material"
                           :material-list="allMaterialList.data"
                           :page="allMaterialList.pageNumber"
                           ref="relationMaterial"
                           @changePage="changeRelationPage"
                           @gotoUrl="gotoDetail"></relation-material>
      </div>
    </div>
  </div>
</template>

<script>
// 知识卡片
import knowledgeCard from './components/knowledge-card'
// 国家图谱
import countryGraph from './components/radialGraph'
// 期刊
import relationMaterial from './components/relationMaterial'
import {
  baseUrl
} from '@/common/js/http/pdBase'
import * as _ from 'lodash'
import MixinDateTime from '@/views/TheHome/mixins/dateTime'
import MixinUpdateData from '@/views/TheHome/mixins/updateData'
import MixinMessageGraph from './mixins/messageGraph'
// import getReportImage from '@/common/mixins/canvasImg'
import ClassfyBreadCrumb from './components/classfyBreadCrumb'
import ItemDetail from '../../search/reportDetail/components/itemDetail'
import echarts from 'echarts'
import searchMap from '../../search/utils/searchMap'
import SelectionList from '../../TheHome/components/selectionList'
import MixinsHandleGraph from '@/views/TheHome/mixins/handleGraph'
import MixinsReportRoute from '@/views/TheHome/mixins/reportRoute'
import MixinSearchEntity from '@/views/TheHome/mixins/searchEntity'
import MixinJumpSearch from '@/views/search/mixin/jumpSearch'
import VideoList from './components/videoList'
import pie from '@/views/topics/chinaTopics/components/pie'
import moreLine from '@/views/topics/chinaTopics/components/moreLine'
import getReportImage from './mixins/canvasImg'
import DateRange from '@/views/topics/DateRange'
import CharacterColumn from '@/views/TheHome/components/characterColumn'
import ClassifyTabs from '@/views/search/components/classifyTabs'
import SelectPopcomfirm from '@/views/TheHome/components/selectPopcomfirm'

export default {
  name: 'nationalCityTopics',
  components: {
    SelectPopcomfirm,
    DateRange,
    CharacterColumn,
    SelectionList,
    VideoList,
    ClassfyBreadCrumb,
    ItemDetail,
    pie,
    ClassifyTabs,
    knowledgeCard,
    countryGraph,
    relationMaterial,
    moreLine
  },
  mixins: [MixinUpdateData, MixinDateTime, MixinsHandleGraph,
    MixinsReportRoute, MixinSearchEntity, MixinJumpSearch,
    MixinMessageGraph],
  data () {
    return {
      SelectFilters: [],
      selectVisible: false,
      dataPicker: [],
      isFull: false,
      filter: { // 筛选相关
        startTime: '',
        endTime: '',
        searchmatter: 'Beijing' // 搜索词
      },
      extraData: {
        startTime: '',
        endTime: ''
      },
      echarts: [
        'Knowledge',
        'Graph',
        'RelationMaterial',
        'AllData',
        'Pie',
        'MoreLine',
        'VideoList'
      ],
      relationGraph: [ // 点击节点触发update的图表
        'AllData'
      ],
      conceptName: 'Beijing', // 概念名称
      timeOption: [
        {
          label: '时间筛选',
          value: 0
        },
        {
          label: '一个月内',
          value: 1
        }, {
          label: '三个月内',
          value: 2
        }, {
          label: '半年内',
          value: 3
        }],
      allType: [101, 100, 99, 98, 97, 96],
      allMaterialList: {
        data: [],
        pageNumber: 0,
        pageSize: 12,
        pageCount: 0,
        token: ''
      },
      itemDetailValue: {
        page: 1,
        size: 10,
        pageCount: 0,
        isDetail: false,
        load: false,
        spaceEndShow: false,
        spaceLoadShow: false,
        content: []
      },
      itemDetailCreate: false,
      selectValue: [],
      breadCrumbValue: {
        content: [
          {
            label: 'Real-time Info',
            value: 'Real-time Info'
          }
        ]
      },
      resultValue: {
        keyWord: '',
        result: ''
      },
      keyWord: '',
      selectType: 'Real-time Info',
      hightQueryBean: [],
      barLabelGrid: {
        top: 30,
        left: 11,
        right: 50,
        bottom: 2,
        containLabel: true
      },
      setTime: null,
      knowledgeValue: [],
      graphValue: {
        graph: null,
        layout: 'static',
        page: 1,
        size: 20,
        pageCount: 1
      },
      apiAddNode: '/ensearch/tempGraphExplore',
      searchToken: '',
      apiSearchId: '/ensearch/getEntityId',
      apiSearchNode: '/ensearch/graphExplore2',
      provinceList: [],
      pieValues: [],
      years: [],
      showPieIndex: 0,
      moreLine: {
        select: [],
        data: {},
        value: {}
      },
      videoMessage: {
        content: [],
        total: 0,
        pageSize: 10,
        pageNo: 0,
        token: ''
      },
      column: { // 二级栏目存放列表
        'Real-time Info': []
      },
      columnApi: {
        'Real-time Info': '/search/getSubCat/en'
      },
      isKeep: false
    }
  },
  watch: {
    'filter.searchmatter' () {
      if (this.$route.name === 'chinaTopics') {
        this.changeSearchList()
      }
    },
    '$route.params': {
      handler (newVal) {
        if (this.$route.name === 'chinaTopics') {
          if (this.filter.searchmatter !== newVal.country || this.conceptName !== newVal.country){
            this.isKeep = false
          }
          if (!this.isKeep) {
            this.filter.searchmatter = newVal.country || 'Beijing'
            this.conceptName = newVal.country || 'Beijing'
            this.$nextTick(() => {
              this.searchId().then((data) => {
                this.allMaterialList.pageNumber = 0
                this.itemDetailValue.page = 1
                this.graphValue.page = 1
                this.videoMessage.pageNo = 0
                this.updateEcharts()
              })
            })
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    this.$store.state.footerShow = false
  },
  mounted () {
    this.getColumn()
    this.getProvinceList()
  },
  activated () {
    this.isKeep = false
  },
  deactivated () {
    this.isKeep = true
  },
  methods: {
    getColumn () {
      for (let key in this.column) {
        this.getAxiosColumn(key)
      }
    },
    getAxiosColumn (type) {
      this.$pdAxios({
        url: this.columnApi[type],
        method: 'get',
        // baseURL: 'http://xinhuasilu-dev.kg.plantdata.cn/kgapi'
        baseURL: baseUrl
      })
          .then((data) => {
            if (data.data.errCode === 200) {
              const _data = data.data.data
              const arr = []
              if (_data) {
                for (let key in _data) {
                  const o = {
                    value: key,
                    key: key,
                    children: []
                  }
                  o.children = _data[key].map((item) => {
                    return {
                      value: item,
                      key: item
                    }
                  })
                  !o.children.length && delete o.children
                  arr.push(o)
                }
                const item = _.find(arr, ['value', 'Real-time Info'])
                this.column[type] = item && item.children || []
                if (this.selectValue.length) {
                  const columnMessage = this.createCatName(this.selectType)
                  columnMessage.isExist && this.selectValue.unshift(columnMessage.column)
                  for (let item of selectValue) {
                    if (item && item.k.name) {
                      item.k._name = searchMap.chinaToEnglish[item.k.name] || ''
                    }
                  }
                }
              }
            }
          })
    },
    // 创建二级栏目
    createCatName (type) {
      const obj = {
        d: '0',
        k: {
          columnItem: 'catName.keyword',
          name: '二级栏目',
          type: 'terms'
        },
        v: []
      }
      let columnItem = []
      if (type === 'Real-time Info') {
        Object.getOwnPropertyNames(this.column).forEach((key) => {
          Array.isArray(this.column[key]) && columnItem.push(...this.column[key])
        })
      } else {
        columnItem = this.column[type]
      }
      obj.v = columnItem
      return {
        isExist: columnItem && columnItem.length,
        column: obj
      }
    },
    search () { // 图谱中的搜索
      if (this.setTime) {
        clearTimeout(this.setTime)
      }
      this.setTime = setTimeout(() => {
        this.searchId().then((data) => {
          this.filter.endTime = ''
          this.filter.startTime = ''
          if (this.dataPicker && this.dataPicker.length) {
            this.filter.endTime = this.dataPicker[1]
            this.filter.startTime = this.dataPicker[0]
          }
          this.extraData.endTime = this.filter.endTime
          this.extraData.startTime = this.filter.startTime
          this.conceptName = this.filter.searchmatter
          if (this.filter.searchmatter !== this.$route.params.country) {
            this.$router.replace({ params: { country: this.filter.searchmatter } })
          } else {
            this.updateEcharts()
          }
        })
      }, 500)
    },
    changeGraph (event, arg) { // 点击graph节点触发
      // if (arg.clickItem && arg.clickItem.data && arg.clickItem.data.conceptName === '国家') {
      //   this.conceptName = arg.clickItem.title
      //   if (this.setTime) {
      //     clearTimeout(this.setTime)
      //   }
      //   this.setTime = setTimeout(() => {
      //     this.updateEcharts('relationGraph')
      //   }, 500)
      // }
    },
    selectItem (val) {
      this.SelectFilters = val
      this.requestAllData(false)
      this.$refs.selectionList && this.$refs.selectionList.scrollTop()
    },
    clickNode (event) {
      if (this.selectVisible) {
        const dom = $('.select-dialog-wrap')[0]
        const button = $('.select-button')[0]
        const path = event.path
        if (path) {
          const isButton = _.findIndex(path, (item) => {
            return item === button
          })
          const isSame = _.findIndex(path, (item) => {
            return item === dom
          })
          if (isButton === -1) {
            isSame === -1 && (this.selectVisible = false)
          }
        }
      }
    },
    selectTab () { // 筛选弹窗
      this.selectVisible = !this.selectVisible
    },
    getProvinceList () {
      this.$pdAxios({
        method: 'post',
        url: '/ensearch/province',
        baseURL: baseUrl
      })
          .then((data) => {
            if (data.data.errCode === 200) {
              const _data = data.data.data
              this.provinceList = _data
            }
          })
    },
    changeType (val) {
      this.selectVisible = false
      this.selectType = val.value
      this.requestAllData()
    },
    requestPie () {
      this.$pdAxios({
        method: 'post',
        url: '/ensearch/country/' + this.id,
        baseURL: baseUrl
      })
          .then((data) => {
            if (data.data.errCode === 200) {
              this.pieValues.length = 0
              this.years.length = 0
              const _data = data.data.data
              _data.forEach(item => {
                this.years.push(item.year)
                this.pieValues.push(item.series.map(value => {
                  return {
                    ...value,
                    data: value.data.map(val => {
                      return {
                        ...val,
                        unit: value.unit
                      }
                    })
                  }
                }))
              })
            }
          })
    },
    requestMoreLine () {
      this.$pdAxios({
        method: 'post',
        // url: '/ensearch/industry/' + this.conceptName,
        url: '/ensearch/industry2/' + this.conceptName,
        baseURL: baseUrl
      })
          .then((data) => {
            if (data.data.errCode === 200) {
              const _data = (data.data.data) || {}
              const arr = []
              for (let key in _data) {
                const start = key.lastIndexOf('(')
                const end = key.lastIndexOf(')')
                let name = key
                if (start && end) {
                  const unit = key.slice(start + 1, end)
                  _data[key].yAxis.name = unit
                  name = name.slice(0, start)
                }
                arr.push({
                  label: name,
                  value: key
                })
              }
              //把Urban Per Capita Disposable Income指标换到第二个，20221120
              const arrIndex = arr.findIndex(function(name){return name.label === 'Urban Per Capita Disposable Income'});
              if (arrIndex){
                arr.splice(arrIndex,1,...arr.splice(1, 1, arr[arrIndex]));
              }
              this.moreLine.data = _data
              this.moreLine.select = arr
              if (arr.length) {
                this.moreLine.value = _data[arr[0].value]
              } else {
                this.moreLine.value = null
              }
            }
          })
    },
    changeMoreLineValue (item) {
      this.moreLine.value = this.moreLine.data[this.moreLine.select[item].value]
    },
    requestAllData (type = false, page = 1) {
      if (page === 1) {
        this.itemDetailValue.content = []
      }
      this.itemDetailValue.page = page
      this.itemDetailValue.spaceLoadShow = true
      this.itemDetailValue.load = true
      let allType = _.cloneDeep(searchMap.allSearchType)
      const arr = searchMap.searchList[this.selectType]
      if (this.selectType !== 'all') {
        let ite = _.find(searchMap.typeAgg, ['key', this.selectType])
        allType = [ite.id]
      }
      let aggs = _.cloneDeep(searchMap.searchAggs)
      aggs = _.filter(aggs, (item) => {
        item.k && item.k.name.indexOf('行业') !== -1 && (item.k.counts = 1000)
        item.k && item.k.name.indexOf('关键词') !== -1 && (item.k.counts = 1000)
        return _.indexOf(arr, item.k.name) !== -1 && (item.k.name === '行业' || item.k.name === '中国省份')
      })
      let data = {
        aggs: aggs,
        docTypeList: allType,
        kw: this.conceptName,
        featureWeights: [],
        filters: [],
        hieghtQueryBean: _.cloneDeep(this.hightQueryBean),
        isExplain: false,
        pageNo: this.itemDetailValue.page,
        pageSize: this.itemDetailValue.size,
        templateId: '',
        current: 0,
        sorts: '1', // 1降序 0升序
        sortField: 'published',
        isAggs: 1,
        psn: 10005,
        token: this.searchToken
      }
      if (type) {
        data.isFilter = 1
      }
      if (this.dataPicker && this.dataPicker.length) {
        const filter = {
          d: '1',
          k: 'published',
          v: [this.filter.startTime, this.filter.endTime]
        }
        data.filters.push(filter)
      }
      if (this.SelectFilters.length) {
        data.filters.push(...this.SelectFilters)
      }
      if (data.filters && data.filters.length) {
        data.filters = data.filters.filter((item) => {
          if (item.d === '0') {
            const o = {
              midd: 0,
              type: 1,
              value: item.v[0],
              column: `[${item.k}]`
            }
            data.hieghtQueryBean.push(o)
          }
          return item.d !== '0'
        })
      }
      const _data = data
      this.$pdAxios({
        method: 'post',
        url: '/search/simplekw',
        baseURL: baseUrl,
        data: data
      })
          .then((data) => {
            if (data.data.errCode === 200) {
              this.searchToken = data.data.data.token
              this.itemDetailCreate = true
              if (!type) {
                _.forEach(data.data.data.tAggregationItem, (item) => {
                  item.isShow = false
                })
                if (_data.hieghtQueryBean.length === 0) {
                  let selectValue = data.data.data.tAggregationItem
                  const columnMessage = this.createCatName(this.selectType)
                  columnMessage.isExist && selectValue.unshift(columnMessage.column)
                  for (let item of selectValue) {
                    if (item && item.k.name) {
                      item.k._name = searchMap.chinaToEnglish[item.k.name] || ''
                    }
                  }
                  this.selectValue = selectValue
                }
              }
              this.hightQueryBean = []
              this.itemDetailValue.total = data.data.data.rsCount
              this.itemDetailValue.pageCount = _.ceil(this.itemDetailValue.total / this.itemDetailValue.size)
              if (this.itemDetailValue.page > 1) {
                this.itemDetailValue.content = _.concat(this.itemDetailValue.content, data.data.data.rsData)
              } else {
                this.itemDetailValue.content = data.data.data.rsData
              }
            } else if (data.data.message === 'token不合法') {
              this.itemDetailValue.page = this.itemDetailValue.page - 1
            }
            this.itemDetailValue.spaceLoadShow = false
            this.itemDetailValue.load = false
          })
          .catch(() => {
            this.itemDetailValue.spaceLoadShow = false
            this.itemDetailValue.load = false
          })
    },
    drawDom (className, name) {
      getReportImage(className, 'png', name)
    },
    // 相关资料 完成
    requestRelationMaterial () {
      // 分页请求判断
      this.allMaterialList.pageNumber === 0 && (this.$refs.relationMaterial.loading = true)
      const data = {
        'docTypeList': ['All'],
        'kw': this.conceptName,
        'featureWeights': [
          { 'k': '16', 'v': '1' },
          { 'k': '19', 'v': '1.3' },
          { 'k': '18', 'v': '1' },
          { 'k': '17', 'v': '1' },
          { 'k': '20', 'v': '1.5' },
          { 'k': '21', 'v': '2' }
        ],
        'filters': [{ 'k': 'type.keyword', 'v': ['magazine'], 'd': '0' }],
        'hieghtQueryBean': [],
        'isExplain': false,
        'pageNo': this.allMaterialList.pageNumber + 1,
        'pageSize': this.allMaterialList.pageSize,
        'templateId': '3',
        'current': 0,
        'isAggs': 0,
        'isRecovery': true,
        'token': this.allMaterialList.pageNumber ? this.allMaterialList.token : '',
        'psn': 10005,
        'isFilter': 0
      }
      if (this.dataPicker && this.dataPicker.length) {
        const filter = {
          d: '1',
          k: 'published',
          v: [this.filter.startTime, this.filter.endTime]
        }
        data.filters.push(filter)
      }
      if (!this.allMaterialList.pageNumber) {
        this.allMaterialList.data = []
      }
      this.$pdAxios({
        method: 'post',
        url: '/search/simplekw',
        baseURL: baseUrl,
        data: data
      }).then((data) => {
        if (data.data.errCode === 200) {
          const _data = data.data.data.rsData
          const list = _.map(_data, (item) => {
            return {
              imageUrl: item.sourceAsMap.thumb,
              ...item,
              name: item.sourceAsMap.title ? [item.sourceAsMap.title] : []
            }
          })
          this.allMaterialList.data.push(...list)
          this.$refs.relationMaterial.loading = false
          this.allMaterialList.token = data.data.data.token
          this.allMaterialList.pageCount = data.data.data.rsCount
        }
      })
    },
    changeRelationPage (pageNum) {
      if (this.allMaterialList.pageSize * this.allMaterialList.pageNumber < this.allMaterialList.pageCount) {
        this.allMaterialList.pageNumber = pageNum
        this.requestRelationMaterial()
      }
    },
    // 視頻列表
    requestVideoList () {
      if (!this.videoMessage.total || this.videoMessage.pageNo * this.videoMessage.pageSize < this.videoMessage.total) {
        this.videoMessage.pageNo++
      } else {
        return
      }
      this.videoMessage.pageNo === 1 && (this.$refs.videoList.loading = true)
      const data = {
        'docTypeList': ['All'],
        'kw': this.conceptName,
        'featureWeights': [{ 'k': '16', 'v': '2' }, { 'k': '19', 'v': '1' }, { 'k': '18', 'v': '1.3' }, {
          'k': '17',
          'v': '1.5'
        }, { 'k': '20', 'v': '2' }],
        'filters': [{ 'k': 'type', 'v': ['video'], 'd': '0' }],
        'hieghtQueryBean': [],
        'isExplain': false,
        'pageNo': this.videoMessage.pageNo,
        'pageSize': this.videoMessage.pageSize,
        'templateId': '3',
        'current': 0,
        'isAggs': 0,
        'isRecovery': true,
        'token': this.videoMessage.token,
        'psn': 10005,
        'isFilter': 0,
        sortField: 'published',
        sorts: '1',
        templateId: ''
      }
      if (this.dataPicker && this.dataPicker.length) {
        const filter = {
          d: '1',
          k: 'published',
          v: [this.filter.startTime, this.filter.endTime]
        }
        data.filters.push(filter)
      }
      this.$pdAxios({
        method: 'post',
        url: '/search/simplekw',
        baseURL: baseUrl,
        data: data
      })
          .then((data) => {
            if (data.data.errCode === 200) {
              this.videoMessage.pageNo === 1 && (this.$refs.videoList.loading = false)
              this.videoMessage.token = data.data.data.token
              this.videoMessage.total = data.data.data.rsCount
              if (this.videoMessage.pageNo > 1) {
                this.videoMessage.content = _.concat(this.videoMessage.content, data.data.data.rsData)
              } else {
                this.videoMessage.content = data.data.data.rsData
              }
            } else if (data.data.message === 'token不合法') {
              this.itemDetailValue.page = this.itemDetailValue.page - 1
            }
          })
    },
    // 知识卡片 完成
    requestKnowledge () {
      this.$pdAxios({
        method: 'post',
        url: '/ensearch/provinceBasicInfo2/' + this.conceptName,
        baseURL: baseUrl
      }).then((data) => {
        if (data.data.errCode === 200) {
          const _data = data.data.data
          const sort = ['Capital City', 'Land Area', 'Population', 'GDP（RMB bln）', 'GDP Growth（%）', 'Per Capita Gdp（RMB）']
          const arr = []
          for (let value of sort) {
            if (_data[value]) {
              let key = value
              key.indexOf('Gdp') !== -1 && (key = key.replace(/Gdp/, 'GDP'))
              arr.push({ [key]: _data[value] })
              delete _data[value]
            }
          }
          for (let key in _data) {
            if (key) {
              let _key = key
              key.indexOf('Gdp') !== -1 && (_key = key.replace(/Gdp/, 'GDP'))
              arr.push({ [_key]: _data[key] })
            }
          }
          // _data.creatDate = this.timeTampToTime(_data.creatDate)
          this.knowledgeValue = arr
        } else {
          this.knowledgeValue = []
        }
      })
    },
    requestGraph (id) {
      this.searchNode(id)
          .then((data) => {
            if (data.level1HasNextPage === 1) {
              this.graphValue.pageCount = this.graphValue.page + 1
            }
            this.graphValue.graph = data
            // setTimeout(() => {
            //   this.$refs.graph.handleUpdataLayout()
            // }, 400)
            localStorage.setItem('graphNode', JSON.stringify(data.entityList[0]))
          })
    },
    fullGraph () {
      const id = ~~this.id
      let path = this.$route.path
      if (!this.$route.params || !this.$route.params.country) {
        path = this.$route.path + '/'
      }
      path += `/graph/common/?params=${id}`
      this.$router.push({ path })
    },
    countryBarClick () {
      window.location.href =
          `https://data.imsilkroad.com/search/countryDetails_page.jsp?countryName=${this.conceptName}`
    }
  }
}
</script>

<style scoped lang="less">
@import "../../TheHome/style/searchEntity.css";

@media screen and (min-width: 1200px) {
  .search-top {
    min-width: 278px;
  }
}

@media screen and (max-width: 1300px) and (min-width: 769px) {
  /deep/ .pd-panel-float-item {
    display: none !important;
  }
}

@media screen and (min-width: 769px) and (max-width: 1199px) {

  .search-top {
    min-width: 278px;

    .el-select {
      margin: 0 0 0 5px !important;
    }
  }

  /deep/ .p-lg-none {
    display: none;
  }

  .left-know-message {
    padding: 8px !important;

    .knowledge-card {
      /deep/ .foot-message {
        .detail-brief {
          > ul {
            .msg-title {
              margin: 0 0 5px 0 !important;
            }

            li {
              padding: 4px 0 !important;
              align-items: center;

              span:nth-of-type(1) {
                min-width: 50px !important;
              }
            }
          }

          img {
            width: 38% !important;
            height: auto !important;
            object-fit: contain;
          }
        }
      }

      /deep/ .foot-message-detail {
        .el-scrollbar__view {
          li {
            span:nth-of-type(1) {
              min-width: 72px !important;
            }
          }
        }
      }
    }
  }


  /*经济风险坐标*/
  .left-bottom {
    padding: 10px !important;

    /deep/ .cut-button {
      top: 0px !important;
    }
  }

  /*图谱样式*/
  /deep/ .pdvis-change-layout-container {
    display: none !important;
  }

  /deep/ .pdvis-node-legend {
    transform: scale(0.7, 0.7) translate(-25%, 25%);
  }

  /deep/ .pd-panel-float-item {
    .pdvis-change-layout-changer {
      width: 70px;
    }
  }

  /*搜索*/
  .classfy-content {
    padding-top: 10px !important;

    .item-wrap {

      /deep/ .nano-content {
        margin-bottom: 0 !important;
      }
    }
  }

  /*相关材料*/
  .left-relation-material {
    padding: 10px !important;
  }

  /*相关关键词*/
  .left-keyword {
    padding: 10px !important;
  }

  /*右下角聚合*/
  .bars-wrap {
    position: relative;
    /*padding: 0px !important;*/

    /deep/ .bars-head {
      margin: -6px !important;
    }

    .bar-label-rotaion {
      height: calc(100% - 40px) !important;
    }
  }
}

@media screen and (min-width: 767px) {
  .national-content {
    /*max-width: 1740px;*/
    height: calc(100vh - 100px) !important;
    margin: 0 auto;
  }

  .left-content {
    min-width: 25%;
    max-width: 25%;
    height: 100%;
  }

  .content-graph {
    width: 52%;
    height: 100%;
    margin: 0 16px;
  }

  .right-message {
    width: 32%;
    height: 100%;
    overflow: hidden;
  }
}

@media screen and (max-width: 766px) {
  .search-top {
    width: calc(100% - 95px) !important;
  }

  .china-topics-content {
    height: auto !important;
  }

  /deep/ .pdvis-change-layout-container {
    display: none !important;
  }

  .national-content {
    flex-wrap: wrap;
    max-width: 730px;
    height: auto;
    /*margin: 0 auto;*/
  }

  .left-content {
    width: 100%;
    height: 900px;
    margin-bottom: 10px;
  }

  .content-graph {
    width: 100%;
    height: 700px;
  }

  .right-message {
    width: 100% !important;
    height: 1000px !important;
    margin-top: 10px !important;
  }

  .common-sm {
    width: 100% !important;
    margin-top: 10px !important;
  }

  .nagative-bar-box {
    margin: 12px 0;
  }

  .foot-message {
    flex-wrap: wrap;
  }

}

.fullscreen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  bottom: 0 !important;
  right: 0 !important;
  z-index: 999;
  width: auto !important;
  height: auto !important;
}

.national-content {
  padding: 0 16px 16px 16px;
  width: 100%;
  height: 100%;
  display: flex;
  box-sizing: border-box;
}

.left-bottom, .left-keyword {
  // margin: 16px 0 0 0;
  padding: 10px 10px 10px 16px;
  width: 100%;
  height: 50%;
  background: #ffffff;
  position: relative;

  .title {
    width: calc(100% - 53px);
    color: #303133;
    padding: 0px;
    font-size: 16px;
    font-weight: bolder;
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .keyword-tabs {
    /deep/ .el-tabs__item, /deep/ .el-tabs__nav-prev, /deep/ .el-tabs__nav-next {
      line-height: 30px !important;
      height: 30px !important;
    }

    /deep/ .el-tabs__item {
      padding: 0 10px !important;
    }

    /deep/ .el-tabs__item, /deep/ .el-tabs__active-bar {
      max-width: 150px !important;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .more-line {
    height: calc(100% - 18px - 30px);
  }

  .more-btn {
    position: absolute;
    top: 7px;
    right: 11px;
    z-index: 1;
    color: #0078FF !important;
    border-left: 0;
    background: transparent;
  }
}

.bars-wrap {
  width: 100%;
  /*height: calc(28% - 16px);*/
  height: calc(50% - 16px);
  margin-top: 16px;
  padding: 10px 5px 5px 16px;
  background: #ffffff;
  overflow: hidden;
  position: relative;

  .pie-select {
    position: absolute;
    width: 80px;
    top: 6px;
    z-index: 2;
    right: 14px;
  }
}


.classfy-content {
  width: 100%;
  margin: 16px 0 0 0;
  height: 44%;
  background: #ffffff;
  padding: 10px 16px 10px;
  position: relative;

  .classify-bread-crumb {
    padding: 0 0 16px 0 !important;
  }

  .selection-list-wrap ul {
    margin: auto;
  }

  /deep/ .item-head-left {

    /deep/ .text-span {
      border-color: #208EFF !important;
      color: #208EFF !important;
    }
  }

  /deep/ .selection-list-wrap ul li {
    margin: 1% 0 !important;
  }

  /deep/ .nodata.text-center.item-wrap {
    img {
      padding-top: 20px;
    }
  }
}

.classify-bread-crumb {
  padding: 16px !important;
}

.item-wrap {
  height: calc(100% - 30px) !important;

  /*/deep/ .consulList li.border-bottom {*/
  /*  padding: 16px 0 !important;*/

  /*  .item-text {*/
  /*    margin: 12px 0;*/
  /*    -webkit-line-clamp: 2 !important;*/
  /*  }*/
  /*}*/
}

.nagative-bar-box {
  width: 100%;
  height: calc(24% - 16px);
  /*flex: 0 1 24%;*/
  /*min-height: 200px;*/
  background: #ffffff;
  margin: 16px 0;
  position: relative;
}

.right-message {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.bar-label-rotaion {
  width: 100%;
  height: calc(100% - 50px);
  /*margin: 18px 0;*/
  /*padding: 0 16px 16px;*/

  /deep/ .title {
    top: -4px !important;
  }
}

.pd-progress {
  width: 100%;
  height: 24%;
  /*flex: 0 1 24%;*/
  /*min-height: 215px;*/
  padding: 18px 24px 18px 18px;
  background: #ffffff;

  /deep/ .title {
    margin-right: -2%;
  }

  /deep/ .line {
    margin: 0.1% 0 0 0;
    font-size: 12px;
  }

  /deep/ .line-message {
    font-size: 12px;
  }

  /deep/ .line-progress {
    margin: 1px 0 0 0;
  }
}

.left-know-message {
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  width: 100%;
  height: calc(34% - 16px);
  /*overflow-y: auto;*/
  box-sizing: border-box;
  padding: 16px;
  margin: 0 0 auto 0;
  background: #fff;

  .left-know-message-title {
    font-size: 16px;
    font-weight: bolder;
    color: #303133;
  }
}

/*.right-message > div {*/
/*  flex: 1;*/
/*}*/

.foot-message {
  display: flex;
  align-content: center;
  margin: 18px 0 0 0;
}

.content-graph {
  padding: 0;
}

.graph-wrap {
  background: #ffffff;
  width: 100%;
  height: calc(56% - 16px);
  position: relative;
  margin: 0 0 auto 0;
  box-sizing: border-box;
  padding: 20px 40px 20px 24px;

  .graph-draw {
    position: absolute;
    right: 2px;
    top: 36px;
    width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 0px;
    text-align: center;
    transform: translateY(-50%);
    /*border: 1px solid rgb(220, 223, 230);*/
  }
}

/deep/ .el-input__inner {
  border-radius: 0;
  height: 32px;
  line-height: 32px;
}

/deep/ .el-input__icon {
  line-height: 32px;
}

.search-top {
  display: flex;
  position: absolute;
  top: 20px;
  left: 24px;
  z-index: 99;
  width: calc(100% - 230px - 18px - 40px);
  max-width: 450px;
  align-items: center;
  margin-bottom: 16px;

  /deep/ .form-control {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .el-select {
    width: calc(50% - 36px);
    margin: 0 18px;
  }

  .nav_search {
    top: 35px;
    max-height: 200px;
    overflow: auto;

    > div {
      height: 24px;
      line-height: 24px;
      cursor: pointer;
      &:hover {
        color:#007bff
      }
    }
  }
}

.cut-button {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.knowledge-card {
  width: 100%;
  height: calc(100% - 24px);
}

/*搜索框*/
.input_box {
  width: 50%;
  min-width: 100px;
  height: 32px;
  margin-right: 10px;
  /*margin: 0 0 32px 0;*/
}

.input_box input {
  height: 32px;
  margin-top: 0;
  line-height: 32px;
  background: #FFFFFF;
  color: #303133;
  border-radius: 0;
}

.input_box .search_icon {
  top: 0;
  right: 4px;
  left: auto !important;
  line-height: 32px;
  font-size: 1rem;
  color: #C0C4CC;
}

/*图谱*/
.country-graph {
  width: 95%;
  margin: 0 auto;
  height: 100% !important;
  background: #ffffff !important;
}

.graph-draw {
  margin: 0 0 0 auto;
}


/*期刊*/
.left-relation-material {
  height: 100%;
  width: 100%;
  overflow: hidden;
  margin-top: 16px;

  /deep/ .relation-material-container {
    height: calc(100% - 28px) !important;

    .title {
      margin-top: 12px !important;
    }

  }
}

.relation-material {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #fff;


  /*min-height: 190px;*/
}

.bars-head {
  display: flex;
  align-items: center;
  padding: 0;
}

.left-bottom-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 66%;
  margin: 16px 0 0 0;
  // background: #fff;
}

.topics-title {
  font-size: 16px;
  font-weight: bolder;
  color: #515a6e;
  padding: 12px 0 0 16px;
  margin: 0 0 -4px 0;
  height: 45px;

  p {
    height: 16px;
    line-height: 16px;
    padding: 0 0 0 12px;
    border-left: 2px solid #007bff;
  }
}

.china-topics-content {
  height: calc(100vh - 62px);
}

/deep/ .cursor {
  cursor: pointer;
}

.select-dialog-wrap {
  width: calc(100% - 48px) !important;
  height: auto !important;
  /*height: 200px;*/
  position: absolute;
  z-index: 999;
  background: #ffffff;
  top: 54px;
  left: 24px;
}

.classfy-content-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 6px;

  .classify-bread-crumb {
    padding: 5px 0 !important;
  }
}

.no-data {
  text-align: center;
  padding-top: 32px;
}
</style>
